/**
 * @generated SignedSource<<3d9b57d0d6443ce0e8343fcf5e3bba81>>
 * @relayHash ed39aef73947885451afd143800c5eb7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/459.0.0-2024-04-25T15:44:41.304Z/CreatorsSearchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreatorsSearchQuery$variables = {
  value?: string | null;
};
export type CreatorsSearchQuery$data = {
  readonly viewer: {
    readonly creators: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly displayName: string | null;
          readonly serviceId: string | null;
          readonly statuses: {
            readonly ART: string | null;
            readonly FASHION: string | null;
            readonly FURNITURE: string | null;
            readonly JEWELRY: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  };
};
export type CreatorsSearchQuery = {
  response: CreatorsSearchQuery$data;
  variables: CreatorsSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contains",
    "variableName": "value"
  },
  {
    "kind": "Literal",
    "name": "creatorStatus",
    "value": [
      "approved"
    ]
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "CreatorStatuses",
  "kind": "LinkedField",
  "name": "statuses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "FURNITURE",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "JEWELRY",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "FASHION",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ART",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatorsSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CreatorListConnection",
            "kind": "LinkedField",
            "name": "creators",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CreatorListEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Creator",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatorsSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CreatorListConnection",
            "kind": "LinkedField",
            "name": "creators",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CreatorListEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Creator",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/459.0.0-2024-04-25T15:44:41.304Z/CreatorsSearchQuery",
    "metadata": {},
    "name": "CreatorsSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a540a75c9d8c68d0151e8051446eacfb";

export default node;
